// Stable per-id color from a palette, for icon avatars keyed on a GUID (or any string)
// user id. `Number(guid)` is always NaN — a GUID isn't a numeric string — so a naive
// Number()-based index collapses every id to the same palette entry. This sums char
// codes instead, which works for any string id.
export const colorForId = (id, palette) => {
  const str = String(id ?? '');
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash + str.charCodeAt(i)) | 0;
  }
  return palette[Math.abs(hash) % palette.length];
};

// Same helper as UserDrilldownModal.jsx's initialOf — the letter shown inside a
// letter-avatar circle, kept here so both places don't redefine it separately.
export const initialOf = (str) => (str ? String(str).trim().charAt(0).toUpperCase() : '?');
